<template>
  <div id="project-detail" v-if="project !== null">
    <div class="container">
      <div class="row">

        <div class="col-xs-12">
          <div class="controls pull-right">
            <span v-show="hasLess" class="chev left" @click="prev()"></span>
            <span v-show="hasMore" class="chev right" @click="next()"></span>
          </div>
        </div>

        <div class="col-xs-12 project-info">
          <div class="row">

            <div class="col-xs-12">
              <div class="project-info">


                <!-- Project Image. -->
                <div class="col-xs-12 col-sm-7">
                  <img v-for="src in project.src" class="project-img img-responsive" :src="imageSrc(src)">
                </div>

                <!-- Project Detail -->
                <div class="col-xs-12 col-sm-5">
                  <h3 class="name">{{ project.name }}</h3>

                  <p v-if="hasDescription" v-html="project.body">
                  </p>

                  <ul>
                    <li v-if="hasClient"><strong>Client</strong>: {{project.client}}</li>
                    <li v-if="hasUrl"><strong>URL</strong>:
                      <a :href="project.website">View Project</a>
                    </li>

                    <!-- If multiple bullets. -->
                    <ul v-if="hasMultipleBullets" class="bullet-list">
                      <li><strong>Our Services:</strong></li>
                      <li v-for="bullet in project.bullets" class="bullet">{{ bullet }}</li>
                    </ul>

                    <!-- If only one bullet. -->
                    <li v-else>{{ project.bullets[0] }}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-xs-12">
              <div class="related">

                <h2>related works</h2>

                <div class="col-xs-12 col-sm-10 col-sm-offset-1">
                  <div class="row">

                    <div class="col-xs-12 col-md-4" v-for="project in related">
                      <project-preview :project="project"></project-preview>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Stash from 'services/Stash';
  import ProjectPreview from 'components/ProjectPreview';

  export default {
    components: { ProjectPreview },

    data() {
      return {
        state:   Stash.state,
        project: null,
      };
    },

    beforeRouteEnter(to, from, next) {
      next(vm => vm.handleRouteChange(to, from));
    },

    methods: {

      next() {
        this.$router.push(this.nextProject);
      },

      prev() {
        this.$router.push(this.prevProject);
      },

      handleRouteChange(to) {
        if (to.params.slug !== undefined) {
          const slug = to.params.slug;

          /* eslint-disable */
          const project = this.state.projects.filter(p => p.slug === slug);

          if (project.length > 0) {
            this.project = project[0];
          }

          else {
            this.$router.push({ path: '/404' });
          }
        }
      },

      imageSrc(src) {
        // eslint-disable-next-line global-require, prefer-template, import/no-dynamic-require
        return require('../assets/images/projects/' + this.project.slug + '/' + src);
      },

    },

    computed: {

      projects() {
        return this.state.projects.filter(p => p !== this.project);
      },

      projectIndex() {
        return this.state.projects.findIndex(p => p === this.project);
      },

      hasMultipleBullets() {
        return this.project.bullets.length > 1;
      },

      type() {
        return this.project.type.filter(t => t.toLowerCase() !== 'all')[0];
      },

      related() {
        return this.projects.filter(p => p.type.includes(this.type)).slice(0, 3);
      },

      hasMore() {
        return this.projectIndex < this.projects.length;
      },

      hasLess() {
        return this.projectIndex !== 0;
      },

      nextProject() {
        return { params: { slug: this.state.projects[this.projectIndex + 1].slug } };
      },

      prevProject() {
        return { params: { slug: this.state.projects[this.projectIndex - 1].slug } };
      },

      hasDescription() {
        if (this.project.body === undefined || this.project.body === null) {
          return false;
        }

        return this.project.body.trim().length > 0;
      },

      hasUrl() {
        if (this.project.website === undefined || this.project.website === null) {
          return false;
        }

        return this.project.website.trim().length > 0;
      },

      hasClient() {
        if (this.project.client === undefined || this.project.client === null) {
          return false;
        }

        return this.project.client.trim().length > 0;
      },

    },

    watch: {

      $route(to, from) {
        this.handleRouteChange(to, from);
      },

    },

  };
</script>

<style scoped>
  h2, h3, h4 {
    color: #638E9C;
  }

  h2 {
    text-transform: uppercase;
  }

  h3 {
    margin-top: 0;
  }

  p {
    white-space: pre-line;
    word-wrap: break-word;
    font-family: inherit;
  }

  p, li {
    color: #95989A;
    display: block;

  }

  ul {
    padding-left: 0;
  }

  li {
    cursor: auto;
    margin-left: 0;
    border-bottom: 1px solid #EBEEF0;
    padding: 5px 0;
  }

  li a {
    color: inherit;
  }

  li a:hover {
    text-decoration: none;
  }

  li:last-child {
    border-bottom: none;
  }

  .bullet-list li {
    border-bottom: none;
  }

  .bullet {
    display: list-item;
    border-bottom: none;
    margin-left: 17px;
    padding: 2px 0;
  }

  #project-detail {
    padding-top: 100px;
    padding-bottom: 75px;
  }

  .project-img:first-of-type {
    margin-bottom: 30px;
  }

  .controls, img {
    user-select: none;
  }

  .chev {
    height: 17px;
    width: 10px;
    padding: 17px;
    cursor: pointer;
    display: inline-block;
    border: 1px solid #9F9F9F;
  }

  .chev.left {
    background: url("~assets/images/detail_left_arrow.svg") no-repeat 45% 50%;
    background-size: 35%;
    margin-right: 5px;
  }

  .chev.right {
    background: url("~assets/images/detail_right_arrow.svg") no-repeat 55% 50%;
    background-size: 35%;
    margin-left: 5px;
  }

  .project-info {
    margin-top: 25px;
  }

  .name {
    font-size: 28px;
  }

  .related {
    text-align: center;
    font-size: 34px;
  }

  h2 {
    margin-top: 75px;
    margin-bottom: 35px;
  }

  @media (max-width: 767px) {
    #project-detail {
      padding-top: 100px;
    }

    .project-img {
      margin: 25px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// ProjectDetail.vue?456bf072